import { render, staticRenderFns } from "./specialMedication.vue?vue&type=template&id=197e50b8&scoped=true&"
import script from "./specialMedication.vue?vue&type=script&lang=js&"
export * from "./specialMedication.vue?vue&type=script&lang=js&"
import style0 from "./specialMedication.vue?vue&type=style&index=0&id=197e50b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e50b8",
  null
  
)

export default component.exports